import { forwardRef } from 'react';

import { classNames } from '~/utils/styles';

import { textColorClassNames } from '../text';
import type { HeadingProps } from './Heading.types';

export const Heading = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ as = 'h1', color = 'inherit', className, children, ...props }, forwardedRef) => {
    const classes = classNames(
      {
        'body-250-heavy': as === 'h6',
        'body-200-heavy': as === 'h5',
        'body-100-heavy': as === 'h4',
        'heading-200-heavy': as === 'h3',
        'title-200': as === 'h2',
        'title-100': as === 'h1',
      },
      textColorClassNames[color],
      className,
    );
    const Element = as;

    return (
      <Element className={classes} ref={forwardedRef} {...props}>
        {children}
      </Element>
    );
  },
);
